export default {
  sm: `
    검증된
    글로벌 인프라
  `,
  md: `
    검증된 글로벌 인프라
  `,
};
